export const transportListTitles = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Route name", colWidth: "170px", key: "routeName" },
  { titleName: "Transport Code", colWidth: "110px", key: "transportCode" },
  { titleName: "Vehicle no", colWidth: "110px", key: "vehicleNo" },
  { titleName: "Driver name", colWidth: "120px", key: "driverName" },
  { titleName: "Driver license", colWidth: "120px", key: "driverLicense" },
  { titleName: "Contact number", colWidth: "200px", key: "driverContact" },
];
